
<div class="native-bottom-navbar">
  @for (item of items; track item) {
    <div
      class="native-bottom-navbar-item"
      [class.native-bottom-navbar-item--active]="activeNativeBottomNavbarItem() === item.type"
      [routerLink]="item.route"
    >
      <svg-icon
        [src]="'assets/icons/' + item.icon"
      ></svg-icon>
      <span class="label">{{ item.label | translate }}</span>
    </div>
  }
</div>